import React from 'react';

function StatCard({ label, value, sub, tone }) {
  return (
    <div className={`ab-stat-card${tone ? ` ab-stat-${tone}` : ''}`}>
      <div className="ab-stat-value">{value}</div>
      <div className="ab-stat-label">{label}</div>
      {sub && <div className="ab-stat-sub">{sub}</div>}
    </div>
  );
}

function levelLabel(lvl) {
  if (lvl === 1) return '15 min';
  if (lvl === 2) return '30 min';
  if (lvl >= 3) return '1 h';
  return '—';
}

function AutoBlockStats({ stats, killSwitch }) {
  const kSwitchActive = killSwitch && killSwitch.last_trigger;
  const dist = (stats && stats.active_by_level) || [];
  return (
    <div className="ab-stats-row">
      <StatCard
        label="Bans nas últimas 24h"
        value={stats ? stats.bans_24h : '—'}
      />
      <StatCard
        label={`Bans nos últimos ${stats?.bans_window?.days ?? 7} dias`}
        value={stats?.bans_window?.count ?? '—'}
      />
      <StatCard
        label="Top IP"
        value={stats?.top_ip?.ip ?? '—'}
        sub={stats?.top_ip ? `${stats.top_ip.c} bans` : null}
      />
      <StatCard
        label="Ativos por nível"
        value={dist.length ? dist.map((d) => `${levelLabel(d.escalation_level)}: ${d.c}`).join(' · ') : 'nenhum'}
      />
      {kSwitchActive && (
        <StatCard
          label="Kill-switch acionado"
          value={new Date(killSwitch.last_trigger.at).toLocaleString('pt-BR')}
          sub={killSwitch.last_trigger.reason}
          tone="danger"
        />
      )}
    </div>
  );
}

export default AutoBlockStats;
